import { render, staticRenderFns } from "./ValutazioneTabA.vue?vue&type=template&id=4cfe71cf&"
import script from "./ValutazioneTabA.vue?vue&type=script&lang=js&"
export * from "./ValutazioneTabA.vue?vue&type=script&lang=js&"
import style0 from "./ValutazioneTabA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports